import React from 'react';
import { observer } from 'mobx-react';
import AddExistingUnitFormDialog from './AddExistingUnitFormDialog';
import AddExistingUnitFormDialogService from '../../services/AddExistingUnitFormDialogService';

const AddExistingUnitFormDialogContainer = () => (
  <AddExistingUnitFormDialog
    onChange={AddExistingUnitFormDialogService.form.setValue}
    onSave={AddExistingUnitFormDialogService.handleSave}
    onCancel={AddExistingUnitFormDialogService.handleCancel}
    isOpen={AddExistingUnitFormDialogService.isOpen}
    errors={AddExistingUnitFormDialogService.form.errors}
    values={AddExistingUnitFormDialogService.form.getValues()}
    submitting={AddExistingUnitFormDialogService.submit.fetching}
  />
);

export default observer(AddExistingUnitFormDialogContainer);
